import { useCallback, useContext } from 'react';

import { AppContext } from '../store/AppProvider';
import useUser from '../hooks/useUser';
import { pushToDataLayer } from '../utils/googleTagManager';

export const usePushToDataLayer = () => {
    const { userState } = useContext(AppContext);
    const { isInternal } = useUser();

    const {
        sapContactNo,
        sapAccountNo,
        sapCustomerGroup,
    } = userState?.cognitoUser ?? {};

    const isProd =
        window.location.hostname === 'dealersource.electronics.sony.com';

    const trafficType = !isProd || isInternal ? 'internal' : null;

    return useCallback(
        (eventName, data = {}, isAllowToTrackAll = false) => {
            pushToDataLayer(
                eventName,
                {
                    isProd,
                    trafficType,
                    ...(sapContactNo && { sapContactNo }),
                    ...(sapAccountNo && { sapAccountNo }),
                    ...(sapCustomerGroup && { sapCustomerGroup }),
                    ...data,
                },
                isAllowToTrackAll
            );
        },
        [
            isProd,
            trafficType,
            sapContactNo,
            sapAccountNo,
            sapCustomerGroup,
        ]
    );
};